/**
 * Extracted from angular-ui-bootstrap 0.8.0
 */

export default ['$document', '$location', function ($document) {
    var openElement = null;
    var _closeMenu = angular.noop;
    return {
        restrict: 'CA',
        link: function link(scope, element) {
            scope.$watch('$location.path', function () {
                _closeMenu();
            });
            element.parent().bind('click', function () {
                _closeMenu();
            });
            element.bind('click', function (event) {
                var elementWasOpen = element === openElement;

                event.preventDefault();
                event.stopPropagation();

                if (openElement) {
                    _closeMenu();
                }

                if (!elementWasOpen && !element.hasClass('gw-disabled') && !element.prop('disabled')) {
                    element.parent().addClass('gw-open');
                    openElement = element;
                    _closeMenu = function closeMenu(_event) {
                        if (_event) {
                            _event.preventDefault();
                            _event.stopPropagation();
                        }
                        $document.unbind('click', _closeMenu);
                        element.parent().removeClass('gw-open');
                        _closeMenu = angular.noop;
                        openElement = null;
                    };
                    $document.bind('click', _closeMenu);
                }
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/dropdown/directives/DropdownToggleDirective.js
// module id = 1112
// module chunks = 0